<template>
    <div>
        <v-toolbar
            dense
            tabs
            color="primary darken-2"
            dark
            class="page_title"
        >
            <v-toolbar-title class="pa-0 pr-0 mt-1">
                <v-layout row >
                    <v-flex xs10 sm11 text-xs-left>
                        <a href="javascript: history.go(-1)" class="pa-0">
                            <v-btn flat fab small class="pa-0">
                                <i class="fas fa-arrow-left headline"></i>
                            </v-btn>
                        </a>
                        Frequently Asked Questions
                    </v-flex>
                    <v-flex xs2 sm1 text-xs-right>
                        <router-link :to="$store.state.close_url" class="pa-0 text-xs-right">
                            <v-btn flat fab small class="pa-0">
                                <i class="fas fa-close headline"></i>
                            </v-btn>
                        </router-link>
                    </v-flex>
                </v-layout>
            </v-toolbar-title>
            
            <v-spacer></v-spacer>
            <v-tabs
                v-model="tabs"
                color="transparent"
                slider-color="white"
                slot="extension"
            >
                <v-tab 
                    v-for="tabsItem in tabsItems"
                    :key="tabsItem.id"
                    :to="tabsItem.link"
                >
                    <span class="pl-1 pr-1" >{{ tabsItem.title }}</span>
                </v-tab>
            </v-tabs>
        </v-toolbar>

        <v-container>
            <v-layout row>
                <v-flex xs12 md8 offset-md2>
                    <v-slide-y-transition mode="out-in">
                        <router-view/>
                    </v-slide-y-transition>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabs: null,
                tabsItems: [
                    {id: 1, title: 'Savings', link: '/faqs/types/savings'},
                    {id: 2, title: 'Market Place', link: '/faqs/types/market_place'},
                    {id: 3, title: 'Njangi', link: '/faqs/types/njangi'},
                    {id: 4, title: 'Funding', link: '/faqs/types/funding'},
                    {id: 5, title: 'Monitor', link: '/faqs/types/monitor'},
                ]
            }
        }
    }
</script>

<style scoped>

</style>
